<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    $route(to) {
      const loginPath = "/admin/login";
      if (
        !this.$store.getters.isSignedIn
        && to.path !== loginPath
      ) {
        this.$router.push(loginPath);
      }
    }
  },
  created() {
    if (!this.$store.getters.isSignedIn
      && !this.$route.path.startsWith("/admin/login")) {
      this.$router.push("/admin/login");
    }
  }
};
</script>

<style>
</style>
